export const environment = {
  production: false,
  apiUrl: "/api",
  authBaseUrl: "https://api.staging.slomio.com",
  tenantRuntime: { slug: "wl-nxt-level", displayName: "WL NXT LEVEL" },
  stripePublishableKey: "pk_test_51P7kJeKikSlEATTTQrjCZZNZxCWMtEiOX6dvcB6cBTJFTPHHFHmYiJsNl80QkpWRAB5I1Pw6J1QrwkZeBLmfmsvD00Aeul198B"
};
